import React, { useState } from 'react';
import OrderEditConfirmCancelModal from './OrderEditConfirmCancelModal';
import { Button, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faTrashRestore } from '@fortawesome/free-solid-svg-icons';
import { orderStatuses } from '../util/constants';

import SolarOrdersApiClient from '../../../apiClient/SolarOrdersApiClient';
import type { Order } from '../../../api/schemas/OrderSchema';
import type { SolarFarm } from '../../../api/schemas/SolarFarmSchema';
import { useInvalidateAllOrders } from '../../../hooks/useOrders';

interface OrderEditHeaderProps {
  order: Order | undefined;
  solarFarm: SolarFarm | null;
  orderActions: any;
  close: () => void;
}

export const OrderEditHeader = ({
  order,
  solarFarm,
  orderActions,
  close,
}: OrderEditHeaderProps) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const farmName = (solarFarm && solarFarm.name) || '';

  const handleModalShow = () => setShowCancelModal(true);
  const handleModalClose = () => setShowCancelModal(false);

  const { invalidateAllOrders } = useInvalidateAllOrders(order?.uuid);

  const handleModalSubmit = () => {
    if (order?.status !== orderStatuses.CANCELLED) {
      handleConfirmCancel();
    } else {
      handleRestoreCancelledOrder();
    }
  };

  const handleConfirmCancel = () => {
    if (!order) return;

    orderActions.cancelOrder(order.uuid).then(() => invalidateAllOrders());

    close();
    handleModalClose();
  };

  const handleRestoreCancelledOrder = () => {
    if (!order) return;

    const solarOrdersApi = new SolarOrdersApiClient();
    solarOrdersApi
      .restoreCancelledOrder(order.uuid)
      .then(() => {
        invalidateAllOrders();
        handleModalClose();
      })
      .catch(err => {
        console.log(err);
        handleModalClose();
      });
  };

  return (
    <Row>
      <Col sm={10}>{`Order #${order && order.id}: ${farmName}`}</Col>
      <Col sm={2}>
        {order && order.status === orderStatuses.CANCELLED ? (
          <Button className="delete-order-button">
            <FontAwesomeIcon icon={faTrashRestore} onClick={handleModalShow} />
          </Button>
        ) : (
          <Button className="delete-order-button">
            <FontAwesomeIcon icon={faTrash} onClick={handleModalShow} />
          </Button>
        )}
        <OrderEditConfirmCancelModal
          showCancelModal={showCancelModal}
          handleSubmit={handleModalSubmit}
          handleModalClose={handleModalClose}
          isOrderCancelled={order?.status === orderStatuses.CANCELLED}
          orderUuid={order?.uuid}
        />
      </Col>
    </Row>
  );
};
